<div class="system-message" data-automation-id="system-message-modal-container">
    <div class="header-bar top" data-automation-id="system-message-modal-header">
        <button type="button" data-automation-id="system-message-save-button" class="primary-button" *ngIf="hasCreatePermissions"
            (click)="saveChanges()" [disabled]="!isDirty || isBusy">Save</button>
        <button type="button" data-automation-id="system-message-discard-changes-button" class="secondary-button" *ngIf="hasCreatePermissions"
            (click)="discardChanges()" [disabled]="!isDirty || isBusy">Discard Changes</button>
        <button type="button" class="help-button" data-automation-id="system-message-help-button" (click)="openHelp()">
            <i class="fa fa-question"></i>
        </button>
    </div>
    <form class="content" #contentForm="ngForm" data-automation-id="system-message-content" [resBusySpinner]="isBusy"
        [message]="isBusyMessage">
        <res-custom-checkbox automationId="system-message-enable-system-message" [(ngModel)]="enableSystemMessage"
            content="Enable System Message for all users at Login" [marginLeft]="10" [disabled]="isBusy || !hasCreatePermissions"  (ngModelChange)="onChange()" name="enableSystemMessage">
        </res-custom-checkbox>
        <div class="line-container">
            <span>Message text:</span>
            <textarea [(ngModel)]="messageText" [disabled] = '!enableSystemMessage || !hasCreatePermissions' data-automation-id="system-message-text" (ngModelChange)="onChange()" name="messageText" ></textarea>
        </div>
    </form>
</div>